/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Snapshot metadata for the most recently completed period, surfaced when a recurring leaderboard is between periods so the UI can label "Last period's results".
 * @export
 * @interface LeaderboardLastCompletedPeriod
 */
export interface LeaderboardLastCompletedPeriod {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardLastCompletedPeriod
     */
    periodNumber: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardLastCompletedPeriod
     */
    endAt: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardLastCompletedPeriod
     */
    prizesDistributed: boolean;
}

/**
 * Check if a given object implements the LeaderboardLastCompletedPeriod interface.
 */
export function instanceOfLeaderboardLastCompletedPeriod(value: object): value is LeaderboardLastCompletedPeriod {
    if (!('periodNumber' in value) || value['periodNumber'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    if (!('prizesDistributed' in value) || value['prizesDistributed'] === undefined) return false;
    return true;
}

export function LeaderboardLastCompletedPeriodFromJSON(json: any): LeaderboardLastCompletedPeriod {
    return LeaderboardLastCompletedPeriodFromJSONTyped(json, false);
}

export function LeaderboardLastCompletedPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardLastCompletedPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'periodNumber': json['periodNumber'],
        'endAt': json['endAt'],
        'prizesDistributed': json['prizesDistributed'],
    };
}

export function LeaderboardLastCompletedPeriodToJSON(json: any): LeaderboardLastCompletedPeriod {
    return LeaderboardLastCompletedPeriodToJSONTyped(json, false);
}

export function LeaderboardLastCompletedPeriodToJSONTyped(value?: LeaderboardLastCompletedPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodNumber': value['periodNumber'],
        'endAt': value['endAt'],
        'prizesDistributed': value['prizesDistributed'],
    };
}

